import { SDKVoiceFacade, VoiceInfo } from 'modules/sdk/lib';

import { useVoiceStore } from '../voicesStore';

const MAX_FAVORITE_VOICE_SIZE = 50;

export const replaceFavoriteVoices = (voicesSlugs: string[]) => {
  setFavoriteVoices(voicesSlugs, false, true);
};

export const setFavoriteVoices = (voicesSlugs: string[], remove?: boolean, replace?: boolean) => {
  useVoiceStore.setState(state => {
    const allVoices = state.allVoices && state.allVoices.length > 0 ? state.allVoices : SDKVoiceFacade.singleton.getAllVoiceInfos();
    const newFavoriteVoices = voicesSlugs.map(slug => allVoices.find(voice => slug === voice.slug)).filter(v => v !== undefined) as VoiceInfo[];

    if (remove) {
      return {
        favoriteVoices: state.favoriteVoices.filter(({ slug }) => !newFavoriteVoices.some(newVoice => newVoice.slug === slug))
      };
    }

    if (replace) {
      const deduplicatedReplacementVoices = newFavoriteVoices.filter((voice, index, arr) => arr.findIndex(v => v.slug === voice.slug) === index);

      return {
        favoriteVoices: deduplicatedReplacementVoices.slice(0, MAX_FAVORITE_VOICE_SIZE)
      };
    }

    // de-dupe
    const deduplicatedVoices = newFavoriteVoices.filter(newVoice => !state.favoriteVoices.some(existingVoice => existingVoice.slug === newVoice.slug));

    return {
      favoriteVoices: [...deduplicatedVoices, ...state.favoriteVoices].slice(0, MAX_FAVORITE_VOICE_SIZE)
    };
  });
};
